export default function WhyForgetTraining() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const problems = [
    { icon: 'ri-search-eye-line', title: 'Нет диагностики до обучения', desc: 'Программа не учитывает реальный уровень руководителей, специфику компании и бизнес-задачи. Обучение идёт «вслепую».' },
    { icon: 'ri-close-circle-line', title: 'Нет практики на тренинге', desc: 'Теория без отработки на реальных управленческих кейсах компании. Лекции не меняют поведение.' },
    { icon: 'ri-task-line', title: 'Нет домашних заданий', desc: 'После тренинга руководители возвращаются к привычной рутине. Без закрепления 70% информации забывается за неделю.' },
    { icon: 'ri-tools-fill', title: 'Нет внедрения', desc: 'Инструменты не интегрированы в ежедневную работу. Чек-листы не созданы, регламенты не обновлены.' },
    { icon: 'ri-heart-pulse-line', title: 'Нет сопровождения', desc: 'Нет посттренинговых встреч, коучинговых сессий и контроля. Никто не помогает, когда возникают сложности.' },
  ];

  const systemSteps = [
    { label: 'Диагностика', icon: 'ri-search-eye-line', desc: 'Анализ компетенций, сбор обратной связи, выявление точек роста' },
    { label: 'Подготовка', icon: 'ri-file-edit-line', desc: 'Адаптация программы под задачи бизнеса и уровень руководителей' },
    { label: 'Обучение', icon: 'ri-presentation-line', desc: '80% практики, реальные кейсы, отработка инструментов' },
    { label: 'Практика', icon: 'ri-tools-fill', desc: 'Домашние задания, внедрение чек-листов и алгоритмов' },
    { label: 'Сопровождение', icon: 'ri-heart-pulse-line', desc: 'Коучинговые сессии, разбор кейсов, корректировка' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему руководители забывают тренинг уже через неделю
        </h2>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          Проблема не в руководителях — проблема в подходе к обучению. Стандартный формат «пришёл, послушал, ушёл» не работает.
        </p>

        {/* 5 причин */}
        <div className="space-y-4 mb-16">
          {problems.map((problem, i) => (
            <div key={i} className="flex items-start gap-5 bg-red-50/70 border border-red-100 rounded-xl p-5 md:p-6">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className={`${problem.icon} text-xl text-red-500`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-base mb-1">{problem.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{problem.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Авторская система */}
        <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-3">
            Наша система делает обучение устойчивым
          </h3>
          <p className="text-gray-600 text-center mb-10">
            Пять этапов, которые превращают знания в управленческие привычки и бизнес-результаты:
          </p>

          <div className="flex flex-col lg:flex-row items-center justify-center gap-3 lg:gap-4">
            {systemSteps.map((step, i) => (
              <div key={i} className="flex lg:flex-col items-center gap-3 lg:gap-0 w-full lg:w-auto">
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <span className="text-[10px] text-teal-600 font-bold mt-2 lg:mt-1">Этап {i + 1}</span>
                </div>
                <div className="lg:text-center flex-1">
                  <h4 className="font-bold text-gray-900 text-sm mb-1">{step.label}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed hidden lg:block">{step.desc}</p>
                </div>
                {i < systemSteps.length - 1 && (
                  <div className="hidden lg:flex items-center">
                    <i className="ri-arrow-right-line text-teal-400 text-xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить программу обучения
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}